import styled from "styled-components";
import { Button as AntButton, Input as AntInput, Form as AntForm } from "antd";

export const ChangePinContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 18px 16px;
  .ant-form-item-label {
    /* text-align: center; */
    font-size: 16px;
  }
  .ant-input {
    text-align: left;
  }
`;

export const ChangePinTitle = styled.div`
  color: #71207c;
  color: ${(props) => props.theme.textColor};
  font-size: 18px;
  text-align: center;
  line-height: 28px;
  margin: 0px;
  padding: 0px;
  font-weight: 600;
`;

export const ChangePinLabel = styled.div`
  color: ${(props) => props.theme.dark1};
  margin-bottom: 25px;
`;

export const Button = styled(AntButton)`
  border: none;
  font-weight: 600;
  width: 100%;
  .ant-btn {
    animation: none !important;
  }
  @media screen and (max-height: 800px) {
    margin-top: 100px;
  }
  margin-top: 250px;
  background: ${(props) => props.theme.primaryGradient} !important;
  :hover {
    background: ${(props) => props.theme.goldenVertical} !important;
  }
`;

export const Form = styled(AntForm)`
  width: 100%;
  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label {
    padding-left: 10px;
  }

  input {
    border: 1px solid #e1cce0;
    border-radius: 12px;
  }

  input[type="text"],
  input[type="number"] {
    height: 52px;
  }

  input[type="password"] {
    height: 40px;
    font-size: 17px !important;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;
